import { render, staticRenderFns } from "./ComputersGroups.vue?vue&type=template&id=7f45ac68&"
import script from "./ComputersGroups.vue?vue&type=script&lang=js&"
export * from "./ComputersGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports